import { useQuery } from "@apollo/client/react";
import { CountryStatesByCountryDocument } from "@/graphql/generated/operations";
import type { ReferenceOption } from "./use-profile-reference-data";

export interface UseCountryStatesResult {
  states: ReferenceOption[];
  loading: boolean;
}

// Country states are looked up dynamically per selected country, unlike
// the static reference lists in useProfileReferenceData. The query skips
// when no country is selected, so the consumer can call this hook
// unconditionally during a form's lifecycle.
export function useCountryStates(countryId: string | null | undefined): UseCountryStatesResult {
  const { data, loading } = useQuery(CountryStatesByCountryDocument, {
    variables: { input: { countryId: countryId ?? "" } },
    skip: !countryId,
  });
  const states: ReferenceOption[] = (data?.countryStatesByCountry.states ?? []).map((s) => ({
    value: s.id,
    label: s.name ?? s.id,
  }));
  return { states, loading };
}
